import React from 'react';
import {
  RiUserLine,
  RiMailLine,
  RiPhoneLine,
  RiTeamLine,
} from 'react-icons/ri';
import Card from '@/components/ui/cards/Card';

export default function ProfileTab({ waiter }) {
  return (
    <Card className="rounded-xl border border-gray-200 bg-white px-6 pt-6 pb-6">
      <div className="flex items-center gap-2 mb-4">
        <RiUserLine className="text-xl text-slate-700" />
        <h3 className="text-lg font-medium">Profile</h3>
      </div>

      <dl className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-4">
        <div>
          <dt className="text-sm text-gray-500">Name</dt>
          <dd className="mt-1 text-base text-gray-900">{waiter.name}</dd>
        </div>
        <div>
          <dt className="text-sm text-gray-500">Email</dt>
          <dd className="mt-1 text-base text-gray-900">{waiter.email}</dd>
        </div>
        <div>
          <dt className="text-sm text-gray-500">Phone</dt>
          <dd className="mt-1 text-base text-gray-900">{waiter.phone_no}</dd>
        </div>
        <div>
          <dt className="text-sm text-gray-500">Role</dt>
          <dd className="mt-1 text-base text-gray-900">{waiter.role_id?.name}</dd>
        </div>
      </dl>
    </Card>
);
}
